import { useRef, useEffect, useCallback, useMemo } from 'react';
import { SensorAPI } from 'react-beautiful-dnd';
import { useScrollContainer } from './ScrollContainerContext';

export function useScrollCancelDrag() {
  const { scrollContainerRef } = useScrollContainer();
  const isDraggingRef = useRef(false);
  const sensorApiRef = useRef<SensorAPI | null>(null);

  const scrollCancelSensor = useCallback((api: SensorAPI) => {
    sensorApiRef.current = api;
  }, []);

  const sensors = useMemo(() => [scrollCancelSensor], [scrollCancelSensor]);

  const handleDragStart = useCallback(() => {
    isDraggingRef.current = true;
  }, []);

  const handleDragEnd = useCallback(() => {
    isDraggingRef.current = false;
  }, []);

  useEffect(() => {
    const scrollSection = scrollContainerRef.current;
    if (!scrollSection) {
      return;
    }

    const handleScroll = () => {
      if (isDraggingRef.current && sensorApiRef.current) {
        sensorApiRef.current.tryReleaseLock();
        isDraggingRef.current = false;
      }
    };

    scrollSection.addEventListener('scroll', handleScroll);
    return () => scrollSection.removeEventListener('scroll', handleScroll);
  }, [scrollContainerRef]);

  return {
    sensors,
    handleDragStart,
    handleDragEnd,
  };
}
